export const BACKEND_URI = process.env.REACT_APP_BACKEND_URI ?? "";
export const T1_BACKEND_URI = process.env.REACT_APP_T1_BACKEND_URI ?? "";
export const EMS_BACKEND_URI = process.env.REACT_APP_EMS_BACKEND_URI ?? "";
